import { AbstractControl, FormControl } from '@angular/forms';
import {
  AlarmRuleActionDeviceUpdateConfig,
  AlarmRuleActionType,
} from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { AlarmRuleActionFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleAction } from '../base-rule-action';
import { DeviceUpdateAction } from './device-update-action';

export class DeviceUpdateRuleAction extends BaseRuleAction {
  public getDescription(): string {
    return 'common.alarm-rule.action.update-device.description';
  }

  public getIcon(): string {
    return 'device_hub';
  }

  public getName(): string {
    return 'common.alarm-rule.action.update-device.title';
  }

  public getType(): AlarmRuleActionType {
    return AlarmRuleActionType.DEVICE_UPDATE;
  }

  public getEditorComponent(): any {
    return DeviceUpdateAction;
  }

  public override configToFrom(data: AlarmRuleActionDeviceUpdateConfig): Record<string, unknown> {
    return {
      deviceUpdate: data.update,
    };
  }

  public formToConfig(form: AlarmRuleActionFormDto): Record<string, unknown> {
    return {
      update: form.deviceUpdate ?? {},
    };
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      deviceUpdate: new FormControl<Record<string, string>>({}),
    };
  }
}